import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
const META_PIXEL_ID = '1439991990665148';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double-initialization
    if ((window as any).fbq) return;
    try {
      /* Meta Pixel base code (hardened for preview environments) */
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', META_PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      // Never let analytics break the page render
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <SalesPage data-id="element-0" />;
}